import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_NOTE_INPUT } from '../../../../constants'
import { getFeatureFromCache } from '../../../../util/feature-cache'
import { Notes as NotesUnified } from './Notes'
import { NotesLegacy } from './NotesLegacy'
import type { NotesProps } from './useNotesModel'

export const Notes: React.FC<NotesProps> = props => {
  return getFeatureFromCache(FEATURE_UC_IN_WEBREGISTER_NOTE_INPUT) ? (
    <NotesUnified {...props} />
  ) : (
    <NotesLegacy {...props} />
  )
}
